import * as Sentry from '@sentry/browser';

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;

if (dsn) {
  Sentry.init({
    dsn,
    environment:
      document.querySelector('meta[name="sentry-environment"]')?.content ||
      'production',
    integrations: [Sentry.browserTracingIntegration()],
    sampleRate: 1.0,
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (error?.name === 'AbortError') return null;
      if (error?.isFromCancelledTransition) return null;
      return event;
    },
    ignoreErrors: [
      /ResizeObserver loop/,
      /AbortError/,
      /Load failed/,
      /Object Not Found Matching Id:\d+/,
      /SecurityError.*insecure/,
      /Skipping view transition/,
      /webkit\.messageHandlers/,
    ],
  });
}

// Expose for inline scripts that can't use ES imports
if (dsn) {
  window.__captureError = (error, context = {}) => {
    if (error?.name === 'AbortError') return;
    Sentry.captureException(error, { tags: { source: 'network', ...context } });
  };
}

export { Sentry };
